import React from "react";
import type { ProductNotificationSelections } from "../../types/productNotificationMappings";

export const PRODUCT_NOTIFICATION_CHANNELS = [
  { key: "shouldEmail", label: "Email" },
  { key: "shouldWebInbox", label: "Web inbox" },
  { key: "shouldMobileInbox", label: "Mobile inbox" },
  { key: "shouldPush", label: "Push" },
] as const;

export const PRODUCT_NOTIFICATION_CHANNELS_OFF: ProductNotificationSelections = {
  shouldEmail: false, shouldWebInbox: false, shouldMobileInbox: false, shouldPush: false,
};

interface Props {
  value: ProductNotificationSelections;
  onChange: (value: ProductNotificationSelections) => void;
  disabled?: boolean;
  appearance?: "default" | "alpha";
}

export default function ProductNotificationChannelSelector({ value, onChange, disabled = false, appearance = "default" }: Props) {
  const isAlpha = appearance === "alpha";
  return (
    <fieldset disabled={disabled} className="space-y-3">
      <legend className={`text-sm font-semibold ${isAlpha ? "text-v7-ink" : "text-gray-900 dark:text-white"}`}>Notification channels</legend>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {PRODUCT_NOTIFICATION_CHANNELS.map(({ key, label }) => (
          <label key={key} className={`flex items-center gap-2 border p-3 text-sm ${isAlpha ? "rounded-v7-control border-v7-ink/20 bg-v7-white text-v7-ink" : "rounded-lg border-gray-200 bg-white text-gray-700 dark:border-rp-separator dark:bg-rp-surface dark:text-gray-300"}`}>
            <input type="checkbox" checked={value[key]} onChange={event => onChange({ ...value, [key]: event.target.checked })}
              className={`h-4 w-4 ${isAlpha ? "accent-v7-bronze-dark focus:ring-v7-bronze-dark" : "accent-rp-amber focus:ring-rp-amber"}`} />
            {label}
          </label>
        ))}
      </div>
      <p className={`text-xs ${isAlpha ? "text-v7-ink-soft" : "text-gray-500 dark:text-gray-400"}`}>Turn off all channels to keep the product saved with notifications off.</p>
    </fieldset>
  );
}
